(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-view-switch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('catalog-view-switch')) {
    customElements.define('catalog-view-switch', class extends HTMLElement {
      connectedCallback() {
        let columns = '3';
        try { columns = localStorage.getItem('ef-catalog-columns') || columns; } catch {}
        this.apply(columns);
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-columns]');
          if (!button) return;
          this.apply(button.dataset.columns);
          try { localStorage.setItem('ef-catalog-columns', button.dataset.columns); } catch {}
        });
      }
      apply(columns) {
        if (!['2','3','4'].includes(columns)) columns = '3';
        document.documentElement.dataset.catalogColumns = columns;
        document.querySelectorAll('catalog-view-switch button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.columns === columns)));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cattelan-skorpio-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cattelan-skorpio')) {
  customElements.define('cattelan-skorpio', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.size = this.querySelector('[data-size]');
      this.button = this.querySelector('button[type=submit]');
      this.addEventListener('change', () => this.updateVariant());
      this.form.addEventListener('submit', (event) => {
        this.updateVariant();
        if (!this.variant || !this.variant.available || !this.form.reportValidity()) event.preventDefault();
      });
      this.updateVariant();
    }
    updateVariant() {
      const base = this.querySelector('[data-base]:checked');
      this.variant = this.variants.find(v => v.size === this.size.value && v.base === base?.value);
      this.form.elements.id.value = this.variant?.id || '';
      this.button.disabled = !this.variant?.available;
      this.button.textContent = this.variant && !this.variant.available ? this.dataset.unavailable : this.dataset.add;
      if (!this.variant) return;
      this.querySelector('[data-price]').textContent = this.variant.price;
      this.querySelector('[data-ex-price]').textContent = this.variant.exPrice;
      this.querySelector('[data-tax]').textContent = this.variant.tax;
      const mainPrice = document.querySelector('product-info[id^="MainProduct-"] [id^="price-"]');
      if (mainPrice) {
        const gross = mainPrice.querySelector('.price__regular .price-item--regular');
        const net = mainPrice.querySelector('.price__excluding-vat');
        if (gross) gross.textContent = this.variant.price;
        if (net) net.textContent = this.variant.exPrice;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cattelan-zermatt-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cattelan-zermatt')) {
  customElements.define('cattelan-zermatt', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.size = this.querySelector('[data-size]');
      this.button = this.querySelector('button[type=submit]');
      this.addEventListener('change', () => this.updateVariant());
      this.form.addEventListener('submit', (event) => {
        this.updateVariant();
        if (!this.variant || !this.variant.available || !this.form.reportValidity()) event.preventDefault();
      });
      this.updateVariant();
    }
    updateVariant() {
      const base = this.querySelector('[data-base]:checked');
      const top = this.querySelector('input[name="properties[Tabletop finish]"]:checked');
      this.variant = this.variants.find(v => v.size === this.size.value && v.base === base?.value && v.top === top?.value);
      this.form.elements.id.value = this.variant?.id || '';
      this.button.disabled = !this.variant?.available;
      this.button.textContent = this.variant && !this.variant.available ? this.dataset.unavailable : this.dataset.add;
      if (!this.variant) {
        this.querySelector('[data-price]').textContent = this.dataset.selectFinishes;
        this.querySelector('[data-ex-price]').textContent = '';
        this.querySelector('[data-tax]').textContent = '';
        return;
      }
      this.querySelector('[data-price]').textContent = this.variant.price;
      this.querySelector('[data-ex-price]').textContent = this.variant.exPrice;
      this.querySelector('[data-tax]').textContent = this.variant.tax;
      const mainPrice = document.querySelector('product-info[id^="MainProduct-"] [id^="price-"]');
      if (mainPrice) {
        const gross = mainPrice.querySelector('.price__regular .price-item--regular');
        const net = mainPrice.querySelector('.price__excluding-vat');
        if (gross) gross.textContent = this.variant.price;
        if (net) net.textContent = this.variant.exPrice;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["finish-code-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('finish-code-order')) {
  customElements.define('finish-code-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('input', event => {
        if (event.target.matches('input[type="text"][required]')) {
          event.target.setCustomValidity(event.target.value.trim() ? '' : this.dataset.validation);
        }
      });
      this.addEventListener('submit', event => {
        const form = event.target;
        form.querySelectorAll('input[type="text"]').forEach(input => {
          input.value = input.value.trim();
          if (input.required) input.setCustomValidity(input.value ? '' : this.dataset.validation);
        });
        if (!form.reportValidity()) event.preventDefault();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pedrali-finish-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pedrali-finish-order')) {
  customElements.define('pedrali-finish-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('input', event => {
        if (event.target.matches('input[type="text"][required]')) {
          event.target.setCustomValidity(event.target.value.trim() ? '' : this.dataset.validation);
        }
      });
      this.addEventListener('submit', event => {
        const form = event.target;
        form.querySelectorAll('input[type="text"]').forEach(input => {
          input.value = input.value.trim();
          if (input.required) input.setCustomValidity(input.value ? '' : this.dataset.validation);
        });
        if (!form.reportValidity()) event.preventDefault();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-choice')) {
  customElements.define('product-choice', class extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded',()=>this.connectedCallback(),{once:true});
        return;
      }
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-choice-product]').textContent);
      this.config = this.data.config || {};
      this.form = this.querySelector('[data-choice-form]');
      this.button = this.form.querySelector('button[type=submit]');
      this.status = this.querySelector('[data-status]');
      this.topPrice = document.querySelector('[id^="MainProduct-"] [id^="price-"]');
      this.originalTopPrice = this.topPrice?.innerHTML;
      this.fields = [];
      this.variants = [];
      try {
        let page = JSON.parse(this.querySelector('[data-choice-variants]').textContent);
        const seen = new Set();
        while (page) {
          this.variants.push(...page.variants);
          if (!page.next) break;
          const url = new URL(page.next, location.origin);
          if (url.origin !== location.origin || seen.has(url.href)) throw Error('Invalid pagination');
          seen.add(url.href);
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url, {credentials:'same-origin'});
          if (!response.ok) throw Error('Variants unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const script = doc.querySelector('[data-choice-variants]');
          if (!script) throw Error('Variants unavailable');
          page = JSON.parse(script.textContent);
        }
        this.variants = [...new Map(this.variants.map(v=>[v.id,v])).values()];
        this.build();
        this.update();
      } catch (error) {
        this.status.textContent = this.data.text.loading_error;
        this.button.disabled = true;
      }
    }
    element(tag, text, attrs={}) {
      const el=document.createElement(tag);
      if(text !== undefined && text !== null) el.textContent=text;
      for(const [key,value] of Object.entries(attrs)) el.setAttribute(key,value);
      return el;
    }
    build() {
      const documents=this.querySelector('[data-documents]');
      for(const link of this.config.links||[]) documents.append(this.element('a',link.label,{href:link.url,target:'_blank',rel:'noopener'}));
      const note=this.querySelector('[data-notes]');
      for(const text of this.config.notes||[]) note.append(this.element('p',text));
      note.hidden=!note.childElementCount;
      let definitions=this.config.dimensions;
      if(!definitions) definitions=this.data.options.map((label,index)=>({label,index,choices:[...new Set(this.variants.map(v=>v.options[index]))].map(value=>({value,match:[value]}))}));
      for(const [index] of this.data.options.entries()) {
        const mapped=definitions.filter(f=>f.index===index);
        if(!mapped.length || this.variants.some(v=>mapped.some(f=>!f.choices.some(c=>c.match?.includes(v.options[index]))))) throw Error('Configuration has changed');
      }
      if(this.data.single) definitions=[];
      for(const definition of definitions) this.addField(definition,true);
      for(const definition of this.config.extra||[]) this.addField(definition,false);
      this.addField({label:this.data.text.notes,type:'text',required:false,hint:this.config.notesHint||'',multiline:true},false);
      this.form.addEventListener('change',()=>this.update());
      this.form.addEventListener('input',event=>{if(event.target.matches('input[type=text],textarea')){event.target.setCustomValidity(event.target.required&&!event.target.value.trim()?this.data.text.required:'');this.updateSummary();}});
      this.form.addEventListener('submit',event=>{
        this.update();
        for(const input of this.form.querySelectorAll('input[type=text],textarea')){input.value=input.value.trim();input.setCustomValidity(input.required&&!input.value?this.data.text.required:'');}
        if(this.submitting || !this.variant?.available || !this.form.reportValidity()){event.preventDefault();return;}
        this.submitting=true;
        this.button.disabled=true;
        this.status.textContent=this.data.text.adding;
      });
    }
    addField(definition, dimension) {
      const field={...definition,dimension};
      field.id=this.id+'-field-'+this.fields.length;
      field.required=definition.required!==false;
      field.wrapper=this.element('fieldset',null,{class:'ef-choice__field'});
      field.wrapper.append(this.element('legend',field.label));
      field.controls=[];
      const name='properties['+field.label+']';
      if(field.type==='text') {
        const control=this.element(field.multiline?'textarea':'input',null,{name,id:field.id,maxlength:field.multiline?'700':'220'});
        if(!field.multiline)control.type='text';
        if(field.required) control.required=true;
        if(field.placeholder)control.placeholder=field.placeholder;
        control.setAttribute('aria-label',field.label);
        field.controls.push(control);field.wrapper.append(control);
      } else if(field.choices?.some(c=>c.image)) {
        const grid=this.element('div',null,{class:'ef-choice__swatches'});
        for(const [index,choice] of field.choices.entries()){
          const card=this.element('div',null,{class:'ef-choice__swatch'});
          const label=this.element('label',null,{'for':field.id+'-'+index});
          const control=this.element('input',null,{type:'radio',name,value:choice.value,id:field.id+'-'+index});
          control.required=field.required;control.dataset.choice=index;
          if(choice.image){
            const zoom=this.element('button',null,{type:'button',class:'ef-image-zoom','data-image-enlarge':choice.image,'data-image-caption':choice.value,'aria-label':'Enlarge '+choice.value});
            zoom.append(this.element('img',null,{src:choice.image,alt:choice.value,width:'160',height:'114',loading:'lazy',referrerpolicy:'no-referrer'}));
            card.append(zoom);
          }
          label.append(control,this.element('span',choice.value));card.append(label);grid.append(card);field.controls.push(control);
        }
        field.wrapper.append(grid);
      } else {
        const control=this.element('select',null,{id:field.id,name,'aria-label':field.label});
        control.required=field.required;
        control.append(this.element('option',this.data.text.select,{value:''}));
        for(const choice of field.choices||[])control.append(this.element('option',choice.value,{value:choice.value}));
        if(field.choices?.length===1)control.value=field.choices[0].value;
        field.controls.push(control);field.wrapper.append(control);
      }
      if(field.hint)field.wrapper.append(this.element('p',field.hint,{class:'ef-choice__hint'}));
      this.fields.push(field);this.querySelector('[data-fields]').append(field.wrapper);
    }
    value(field) {return field.controls[0]?.type==='radio'?field.controls.find(c=>c.checked)?.value||'':field.controls[0]?.value||'';}
    match(variant,field,value) {
      if(field.index===undefined || field.index===null)return true;
      const choice=field.choices?.find(c=>c.value===value);
      return choice?.match?.includes(variant.options[field.index])||false;
    }
    update() {
      if(!this.fields.length&&!this.data.single)return;
      const dimensions=this.fields.filter(f=>f.dimension);
      for(const [index,field] of dimensions.entries()) {
        for(const choice of field.choices||[]) {
          const allowed=this.variants.some(v=>this.match(v,field,choice.value)&&dimensions.slice(0,index).every(prev=>!this.value(prev)||this.match(v,prev,this.value(prev))));
          const control=field.controls[0]?.type==='radio'?field.controls.find(c=>c.value===choice.value):[...field.controls[0].options].find(o=>o.value===choice.value);
          if(control){control.disabled=!allowed;if(!allowed&&(control.checked||control.selected)){if(control.type==='radio')control.checked=false;else field.controls[0].value='';}}
        }
      }
      const complete=dimensions.every(f=>!f.required||this.value(f));
      const matches=complete?this.variants.filter(v=>dimensions.every(f=>!this.value(f)||this.match(v,f,this.value(f)))):[];
      this.variant=matches.length===1?matches[0]:null;
      for(const field of this.fields.filter(f=>!f.dimension)){
        const active=!field.when||field.when.some(rule=>this.variant&&new RegExp(rule.pattern,'i').test(this.variant.options[rule.index]||''));
        field.wrapper.hidden=!active;
        for(const control of field.controls){control.disabled=!active;control.required=active&&field.required;}
      }
      this.form.elements.id.value=this.variant?.id||'';
      this.button.disabled=!this.variant?.available||this.submitting;
      this.querySelector('[data-price]').textContent=this.variant?.price||this.data.text.select;
      this.querySelector('[data-net]').textContent=this.variant?.net||'';
      this.querySelector('[data-sku]').textContent=this.variant?.sku||'';
      const quantity=this.form.elements.quantity;
      quantity.min=Math.max(this.variant?.min||1,this.config.minimumQuantity||1);quantity.step=this.variant?.step||1;
      if(this.variant?.max)quantity.max=this.variant.max;else quantity.removeAttribute('max');
      if(Number(quantity.value)<Number(quantity.min))quantity.value=quantity.min;
      this.status.textContent=this.variant&&!this.variant.available?this.data.text.unavailable:complete&&matches.length!==1?this.data.text.select:'';
      this.updateMainPrice();
      this.updateSummary();
    }
    updateMainPrice() {
      if(!this.topPrice)return;
      if(!this.variant){this.topPrice.innerHTML=this.originalTopPrice;return;}
      for(const selector of ['.price__regular .price-item--regular','.price__sale .price-item--sale']){const item=this.topPrice.querySelector(selector);if(item)item.textContent=this.variant.price;}
      const compare=this.topPrice.querySelector('.price__sale .price-item--regular');if(compare)compare.textContent=this.variant.compare||'';
      const net=this.topPrice.querySelector('.price__excluding-vat');if(net)net.textContent=this.variant.net;
      const price=this.topPrice.querySelector('.price');if(price){price.classList.toggle('price--on-sale',!!this.variant.on_sale);price.classList.toggle('price--sold-out',!this.variant.available);}
    }
    updateSummary() {
      const summary=this.querySelector('[data-summary]');summary.replaceChildren();
      for(const field of this.fields){const value=this.value(field);if(!value||field.wrapper.hidden)continue;const pair=this.element('div');pair.append(this.element('dt',field.label),this.element('dd',value));summary.append(pair);}
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
